module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1MhOW"))).then(() => parcelRequire('d0iPb'));